const cache = require('./memory-cache/memory-cache');

const referenceCache = new cache.Cache();

module.exports = referenceCache;
